// ?ref=CODE on any page is remembered on this browser for 30 days (localStorage + cookie).
const KEY = "smartin_ref";
const DAYS = 30;

export function captureReferral() {
  const code = (new URLSearchParams(window.location.search).get("ref") || "").trim().toUpperCase();
  if (!/^[A-Z0-9-]{3,40}$/.test(code)) return;
  localStorage.setItem(KEY, JSON.stringify({ code, exp: Date.now() + DAYS * 864e5 }));
  document.cookie = `${KEY}=${code}; max-age=${DAYS * 86400}; path=/; SameSite=Lax`;
}

export function getReferral() {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) || "null");
    if (v && v.exp > Date.now()) return v.code;
  } catch { /* corrupt value falls back to the cookie */ }
  const m = document.cookie.match(/(?:^|; )smartin_ref=([^;]+)/);
  return m ? m[1] : "";
}
